




















































































































































import { Vue, Component } from "@/shared/vuepack";
import * as elements from "@/shared/elementsUrls";
import { AppBrowserTarget, isMobileApp, openUrl } from "@/shared/mobileHelper";

@Component({
  components: {
  }
})
export default class ElementsForms extends Vue {
  ElementsUrls = elements;

  clickLink (event) {
    if (isMobileApp()) {
      openUrl(event.currentTarget.href, AppBrowserTarget.system);
    } else window.open(event.currentTarget.href, event.currentTarget.target);
  }
}
